export const toInt = (num: string | number): number => {
  return ~~num;
};
